import { Component } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { shareReplay } from 'rxjs/operators';

// @ts-ignore
@Component({
  template: '',
})
export abstract class NetworkActiveComponent {
  protected networkActive$$ = new BehaviorSubject<boolean>(false);
  public networkActive$ = this.networkActive$$.asObservable().pipe(shareReplay(1));
}
